const ERROR_SELECTOR = '.ant-legacy-form-item-control.has-error, .has-error, [aria-invalid="true"]';

export function scrollToFirstError(): void {
  requestAnimationFrame(() => {
    const el = document.querySelector<HTMLElement>(ERROR_SELECTOR);

    el?.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
}
